import React, { Component } from 'react';
import Home from './View/Screen/Home/Home.component';
import { withTranslation, WithTranslation } from 'react-i18next';
import './App.scss';

class App extends Component<WithTranslation> {
    render() {
        return (
            <div className="App">
                <Home />
            </div>
        )
    }
}
export default withTranslation()(App);